module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/sofia-a748862ff3157298908913760cf7eae0.jpg";